import { getTrackerCount } from "./initialize";

export const generateGAStorageKey = () =>
  `${Math.random()
    .toString(36)
    .substr(2, 8)}-${Math.random()
    .toString(36)
    .substr(2, 4)}-${Math.random()
    .toString(36)
    .substr(2, 4)}-${Math.random()
    .toString(36)
    .substr(2, 12)}`;

// t + index is the default naming schema ga will generate for unnamed trackers
// by doing this ourselves we setting our default ga id as index zero will have
// ga treat it as the default tracker will also allowing it to be named
export const getTrackerName = (index: number | string) => "t" + index;

// All tracker names are the values from 0 to trackerCount - 1
export const getTrackerNames = () =>
  [...Array(getTrackerCount())].map((_, i) => getTrackerName(i));
